import { v4 as uuid } from "uuid";
import { getCityNames } from "postcodes-tz";
import { TenderStatus } from "./types";


class UTILS {
    MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
    STAFF = 'staff';
    ADMIN = 'admin';
    FINANCE = 'finance';
    SALES = 'sales';
    PAGE_SIZE = 5;
    PROFIT_MARGIN = 1.3;
    BASE_URL = "https://api.mak-david.com/api/v1";
    // BASE_URL = "http://localhost:8001/api/v1";

    TZ_CITIES = getCityNames( 'ASC' );
    MONTHS = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
    COUNTRIES = [
        "Afghanistan",
        "Åland Islands",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas (the)",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory (the)",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands (the)",
        "Central African Republic (the)",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands (the)",
        "Colombia",
        "Comoros (the)",
        "Congo (the Democratic Republic of the)",
        "Congo (the)",
        "Cook Islands (the)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czechia",
        "Côte d'Ivoire",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic (the)",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands (the) [Malvinas]",
        "Faroe Islands (the)",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories (the)",
        "Gabon",
        "Gambia (the)",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (the)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea (the Democratic People's Republic of)",
        "Korea (the Republic of)",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic (the)",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands (the)",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia (Federated States of)",
        "Moldova (the Republic of)",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands (the)",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger (the)",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands (the)",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines (the)",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation (the)",
        "Rwanda",
        "Réunion",
        "Saint Barthélemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan (the)",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan (Province of China)",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands (the)",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates (the)",
        "United Kingdom of Great Britain and Northern Ireland (the)",
        "United States Minor Outlying Islands (the)",
        "United States of America (the)",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela (Bolivarian Republic of)",
        "Viet Nam",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe"
    ];
    //Functions start
    thousandSeparator = ( x ) => {
        return x.toString().replace( /\B(?=(\d{3})+(?!\d))/g, "," );
    }
    randomKey = () => {
        return uuid();
    }
    getMonth = ( index ) => {
        return this.MONTHS[ index ];
    }
    getMonths = () => {
        return this.MONTHS;
    }
    formatDate = ( milliseconds ) => {
        let d = new Date( milliseconds );
        return this.getMonth( d.getMonth() ) + " " + d.getDate() + ", " + d.getFullYear();//.toString().substring(2);
    }
    transactionType = ( type ) => {
        if ( type === 0 ) return <span className="bg-green-300 px-2 py-1 rounded">Cash Sale</span>;
        else if ( type === 1 ) return <span className="bg-yellow-300 px-2 py-1 rounded">Credit Sale</span>;
        else return <span className="bg-gray-300 px-2 py-1 rounded">Unknown</span>;
    }

    paymentType = ( type ) => {
        if ( type === 0 ) return <span className="bg-green-300 px-2 py-1 rounded">Sales</span>;
        else if ( type === 1 ) return <span className="bg-yellow-300 px-2 py-1 rounded">Suppliers</span>;
        else return <span className="bg-red-500 text-white px-2 py-1 rounded">Operational</span>;
    }

    activeStatusBadge = ( status ) => {
        if ( status ) return <span className="bg-green-300 px-2 py-1 rounded">Active</span>;
        else return <span className="bg-red-300 text-white px-2 py-1 rounded">Inactive</span>;
    }

    tenderStatusBadge = ( status ) => {

        switch ( status ) {
            case TenderStatus.PREPARATION:
                return <span className="bg-yellow-300 px-2 py-1 rounded">Preparation</span>;
            case TenderStatus.SUBMITTED:
                return <span className="bg-blue-300 px-2 py-1 rounded">Submitted</span>;
            case TenderStatus.OPEN:
                return <span className="bg-green-300 px-2 py-1 rounded">Open</span>;
            case TenderStatus.AWARDED:
                return <span className="bg-green-700 text-white px-2 py-1 rounded">Awarded</span>;
            case TenderStatus.REJECTED:
                return <span className="bg-red-500 text-white px-2 py-1 rounded">Rejected</span>;
            case TenderStatus.EXECUTION:
                return <span className="bg-blue-700 text-white px-2 py-1 rounded">Execution</span>;
            case TenderStatus.COMPLETED:
                return <span className="bg-green-500 text-white px-2 py-1 rounded">Completed</span>;
            default:
                return <span className="bg-yellow-300 px-2 py-1 rounded">Preparation</span>;
        }

    }

    signout = () => {
        sessionStorage.clear();
        localStorage.clear();
    }
}
export default new UTILS();
